module.exports = __webpack_public_path__ + "img/violet_113.cba747f8.png";